import { useAuthContext, useSiteSettingsContext } from '@core/shared';
import { Navigate } from '@online-webinar/router';

declare module '@tanstack/history' {
    interface HistoryState {
        from?: string;
    }
}

export const authGuard = (
    Component: React.ComponentType,
    {
        canBroadcast,
        isWhitelabel,
        canInviteAccounts,
        canManageTranslations,
        canManageEmailStyle,
        canManageEmailTemplates,
        canManageEmailLists,
        canManageBlacklist,
        canManageChatLinkDomains,
        canViewUsageStatistics,
        hasRights
    }: {
        canBroadcast?: boolean;
        isWhitelabel?: boolean;
        canInviteAccounts?: boolean;
        canManageTranslations?: boolean;
        canManageEmailStyle?: boolean;
        canManageEmailTemplates?: boolean;
        canManageEmailLists?: boolean;
        canManageBlacklist?: boolean;
        canManageChatLinkDomains?: boolean;
        canViewUsageStatistics?: boolean;
        hasRights?: boolean;
    } = {}
) => {
    return (props: any) => {
        const {
            isAuthenticated,
            canBroadcast: userCanBroadcast,
            canInviteAccounts: userCanInviteAccounts,
            canManageTranslations: userCanManageTranslations,
            canManageEmailStyle: userCanManageEmailStyle,
            canManageEmailTemplates: userCanManageEmailTemplates,
            canManageEmailLists: userCanManageEmailLists,
            canManageBlacklist: userCanManageBlacklist,
            canManageChatLinkDomains: userCanManageChatLinkDomains,
            canViewUsageStatistics: userCanViewUsageStatistics,
            hasRights: userHasRights
        } = useAuthContext();

        const fromPath = globalThis?.window?.location?.pathname || '';
        if (!isAuthenticated) {
            let to = '/login';
            if (fromPath.endsWith('/watch') || fromPath.endsWith('/on-demand')) {
                to = '/$webinarId/login';
            }

            return <Navigate to={to} state={{ from: fromPath }} />; // or redirect to login page
        }

        if (canBroadcast && !userCanBroadcast) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />; // or redirect to unauthorized page
        }

        if (canInviteAccounts && !userCanInviteAccounts) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />; // or redirect to unauthorized page
        }

        if (canManageTranslations && !userCanManageTranslations) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />; // or redirect to unauthorized page
        }

        if (canManageEmailStyle && !userCanManageEmailStyle) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />; // or redirect to unauthorized page
        }

        if (canManageEmailTemplates && !userCanManageEmailTemplates) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />; // or redirect to unauthorized page
        }

        if (canManageEmailLists && !userCanManageEmailLists) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />; // or redirect to unauthorized page
        }

        if (canManageBlacklist && !userCanManageBlacklist) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />; // or redirect to unauthorized page
        }

        if (canManageChatLinkDomains && !userCanManageChatLinkDomains) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />; // or redirect to unauthorized page
        }

        if (canViewUsageStatistics && !userCanViewUsageStatistics) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />;
        }

        if (hasRights && !userHasRights) {
            return <Navigate to="/access-denied" state={{ from: fromPath }} />; // or redirect to unauthorized page
        }

        if (isWhitelabel) {
            const siteIsWhitelabel = useSiteSettingsContext().isWhitelabel;
            if (!siteIsWhitelabel) {
                return <Navigate to="/not-found" state={{ from: fromPath }} />; // or redirect to not found page
            }
        }
        return <Component {...props} />;
    };
};
